import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-receipt-grid',
  templateUrl: './receipt-grid.component.html',
  styleUrls: ['./receipt-grid.component.css']
})
export class ReceiptGridComponent implements OnInit {

  title = "Receipt Details";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/finance/receipt/receipt-grid/receipt-grid.component.ts